import Uketsuke from '@/Uketsuke/UketsukeApp.vue';
import uketsukeMenu from '@/Uketsuke/templates/UketsukeMenu.vue';
import applicationForm from '@/Uketsuke/templates/ApplicationForm.vue';
import applicationFormConfirm from '@/Uketsuke/templates/ApplicationFormConfirm.vue';
import applicationFormConfirmPrint from '@/Uketsuke/templates/ApplicationFormConfirmPrint.vue';
import applicationFormConfirmChange from '@/Uketsuke/templates/ApplicationFormConfirmChange.vue';
import applicationFormConfirmChangePrint from '@/Uketsuke/templates/ApplicationFormConfirmChangePrint.vue';
import municipalitySelect from '@/Uketsuke/templates/MunicipalitySelect.vue';
import partialInfoConstruction from '@/Uketsuke/templates/PartialInfoConstruction.vue';
import partialInfoConsulting from '@/Uketsuke/templates/PartialInfoConsulting.vue';
import partialInfoMaintenance from '@/Uketsuke/templates/PartialInfoMaintenance.vue';
import partialInfoGoods from '@/Uketsuke/templates/PartialInfoGoodsDetail.vue';
import receptionSlipIssue from '@/Uketsuke/templates/ReceptionSlipIssue.vue';
import uketsukeOrderMain from '@/Uketsuke/templates/UketsukeOrderMain.vue';
import AccepterLogin from '@/Uketsuke/templates/AccepterLogin.vue';
import AccepterTopMenu from '@/Uketsuke/templates/AccepterTopMenu.vue';
import AccepterMainMenu from '@/Uketsuke/templates/AccepterMainMenu.vue';
import AccepterChangePassword from '@/Uketsuke/templates/AccepterChangePassword.vue';
import applicationTraderSearch from '@/Uketsuke/templates/ApplicationTraderSearch.vue';
import accepterUserRegistration from '@/Uketsuke/templates/AccepterUserRegistration.vue';
import applicationAcceptCheck from '@/Uketsuke/templates/ApplicationAcceptCheck.vue';
import passwordIssuerSearch from '@/Uketsuke/templates/PasswordIssuerSearch.vue';
import passwordIssueResult from '@/Uketsuke/templates/PasswordIssueResult.vue';
import checkResult from '@/Uketsuke/templates/ApplicationCheckResult.vue';
import fileUpload from '@/Uketsuke/templates/FileUpload.vue';
import partialInfoCredentials from '@/Uketsuke/templates/PartialInfoCredentials.vue';
import partialInfoMajorCategory from '@/Uketsuke/templates/PartialInfoMajorCategory.vue';
import applicationChangeLog from '@/Uketsuke/templates/ApplicationChangeLog.vue';
//20211007 [07_審査状況確認画面追加]  ueda ADD Start
import applicationReviewStatus from '@/Uketsuke/templates/ApplicationReviewStatus.vue';
//20211007 [07_審査状況確認画面追加]  ueda ADD End
import traderInfoWorkTypes from '@/Uketsuke/custom/templates/TraderInfoWorkTypes.vue';
import ActualPerformanceConstruction from '@/Uketsuke/templates/ActualPerformance.vue'; /** 20211008 [02_実績高整理表] takekawa ADD */
import ActualPerformanceConsulting from '@/Uketsuke/templates/ActualPerformance.vue'; /** 20211008 [02_実績高整理表] takekawa ADD */
import ActualPerformanceMaintenance from '@/Uketsuke/templates/ActualPerformance.vue'; /** 20211008 [02_実績高整理表] takekawa ADD */
import ApplicationListPrint from '@/Uketsuke/templates/ApplicationListPrint.vue'; //20240901 [appListPrint] a-matsui add
import accepterPasswordReconfigRequest from '@/Uketsuke/templates/AccepterPasswordReconfigRequest.vue'; // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add
import accepterPasswordReconfig from '@/Uketsuke/templates/AccepterPasswordReconfig.vue'; // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add

import CustomRouter from './custom/uketsuke-custom-routers';

export default {
  path: '/uketsuke',
  component: Uketsuke,
  children: [
    {
      name: 'uketsukeMenu',
      path: '',
      component: uketsukeMenu,
    },
    {
      name: 'applicationForm',
      path: 'appForm',
      component: applicationForm,
    },
    {
      name: 'applicationFormConfirm',
      path: 'appFormConfirm',
      component: applicationFormConfirm,
    },
    {
      name: 'applicationFormConfirmPrint',
      path: 'appFormConfirmPrint',
      component: applicationFormConfirmPrint,
    },
    {
      name: 'applicationFormConfirmChange',
      path: 'appFormConfirmChange',
      component: applicationFormConfirmChange,
    },
    {
      name: 'applicationFormConfirmChangePrint',
      path: 'appFormConfirmChangePrint',
      component: applicationFormConfirmChangePrint,
    },
    {
      name: 'municipalitySelect',
      path: 'municipalitySelect',
      component: municipalitySelect,
    },
    {
      name: 'partialInfoConstruction',
      path: 'partialInfo/const',
      component: partialInfoConstruction,
    },
    {
      name: 'partialInfoConsulting',
      path: 'partialInfo/consul',
      component: partialInfoConsulting,
    },
    {
      name: 'partialInfoMaintenance',
      path: 'partialInfo/maintenance',
      component: partialInfoMaintenance,
    },
    {
      name: 'partialInfoGoods',
      path: 'partialInfo/goods',
      component: partialInfoGoods,
    },
    {
      name: 'receptionSlipIssue',
      path: 'receptionSlip',
      component: receptionSlipIssue,
    },
    {
      name: 'uketsukeOrderMain',
      path: 'OrderMain',
      component: uketsukeOrderMain,
    },
    {
      path: 'login',
      name: 'no_auth/accepterLogin',
      component: AccepterLogin,
    },
    {
      path: 'accepterTopMenu',
      name: 'no_auth/accepterTopMenu',
      component: AccepterTopMenu,
    },
    {
      path: 'accepterMainMenu',
      name: 'accepterMainMenu',
      component: AccepterMainMenu,
    },
    {
      path: 'accepterChangePassword',
      name: 'accepterChangePassword',
      component: AccepterChangePassword,
    },
    {
      name: 'applicationTraderSearch',
      path: 'search/trader',
      component: applicationTraderSearch,
    },
    {
      path: 'accepterUserRegistration',
      name: 'no_auth/accepterUserRegistration',
      component: accepterUserRegistration,
    },
    {
      path: 'search/trader/check',
      name: 'checkAppAccept',
      component: applicationAcceptCheck,
    },
    {
      path: 'search/trader/check/result',
      name: 'checkResult',
      component: checkResult,
    },
    {
      path: 'search/passIssuer',
      name: 'passwordIssuerSearch',
      component: passwordIssuerSearch,
    },
    {
      path: 'search/passIssuer/result',
      name: 'passwordIssueResult',
      component: passwordIssueResult,
    },
    {
      name: 'fileUpload',
      path: 'fileUpload',
      component: fileUpload,
    },
    {
      name: 'partialInfoCredentials',
      path: 'partialInfo/credent',
      component: partialInfoCredentials,
    },
    {
      name: 'partialInfoMajorCategory',
      path: 'partialInfo/major',
      component: partialInfoMajorCategory,
    },
    {
      name: 'applicationChangeLog',
      path: 'applicationChangeLog',
      component: applicationChangeLog,
    },
    //20211007 [07_審査状況確認画面追加]  ueda ADD Start
    {
      name: 'applicationReviewStatus',
      path: 'applicationReviewStatus',
      component: applicationReviewStatus,
    },
    //20211007 [07_審査状況確認画面追加]  ueda ADD End
    {
      path: 'traderInfoWorkTypes',
      name: 'traderInfoWorkTypes',
      component: traderInfoWorkTypes,
    },
    /** 20211008 [02_実績高整理表] takekawa ADD Start */
    {
      name: 'actualPerformanceConstruction',
      path: 'actualPerformance/const',
      component: ActualPerformanceConstruction,
    },
    {
      name: 'actualPerformanceConsulting',
      path: 'actualPerformance/consul',
      component: ActualPerformanceConsulting,
    },
    {
      name: 'actualPerformanceMaintenance',
      path: 'actualPerformance/maintenance',
      component: ActualPerformanceMaintenance,
    },
    /** 20211008 [02_実績高整理表] takekawa ADD End */
    //20240901 [appListPrint] a-matsui add start
    {
      name: 'applicationListPrint',
      path: 'applicationListPrint',
      component: ApplicationListPrint,
    },
    // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add start
    {
      path: 'accepterPasswordReconfigRequest',
      name: 'no_auth/accepterPasswordReconfigRequest',
      component: accepterPasswordReconfigRequest,
    },
    {
      path: 'accepterPasswordReconfig',
      name: 'no_auth/accepterPasswordReconfig',
      component: accepterPasswordReconfig,
    },
    // 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add end
    //20240901 [appListPrint] a-matsui add end
    { ...CustomRouter },
  ],
};
